import { getEnvVar } from '@psyomics/ui-common';

const prodLikeEnvironments = ['staging', 'prod', 'uat'];

type Config = {
  debugLogsEnabled: boolean;
  environment: string;
  referralApiClientId: string;
  referralApiCognitoDomain: string;
  referralApiUrl: string;
  postHogApiKey: string;
  postHogHost: string;
  sentryDsn: string;
};

const getConfig = (): Config => {
  const environment = getEnvVar('VITE_ENVIRONMENT');
  const debugLogsEnabled = !prodLikeEnvironments.includes(environment);
  const referralApiClientId = getEnvVar('VITE_REFERRAL_API_CLIENT_ID');
  const referralApiCognitoDomain = getEnvVar('VITE_REFERRAL_API_COGNITO_DOMAIN');
  const referralApiUrl = getEnvVar('VITE_REFERRAL_API_URL');
  const postHogApiKey = getEnvVar('VITE_POSTHOG_API_KEY');
  const postHogHost = getEnvVar('VITE_POSTHOG_HOST');
  const sentryDsn = getEnvVar('VITE_REFERRAL_PORTAL_SENTRY_DSN');

  return {
    debugLogsEnabled,
    environment,
    postHogApiKey,
    postHogHost,
    referralApiClientId,
    referralApiCognitoDomain,
    referralApiUrl,
    sentryDsn,
  };
};

export type { Config };
export { getConfig, prodLikeEnvironments };
